import { styled } from '@biome-design-system/styles';
import { fromTheme } from '@kyruus/ui-theme';
import { List as BaseList } from '@biome-design-system/ui/List';

export const Header = styled('div')`
  position: sticky;
  top: 0;
  height: 60px;

  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${fromTheme('color_background')};
  border-bottom: 1px solid ${fromTheme('color_border')};
  padding: 0 ${fromTheme('spacing_large')};

  & h2 {
    font-size: ${fromTheme('font_size_heading_4')};
    font-weight: ${fromTheme('font_weight_bolder')};
  }
`;

export const List = styled(BaseList)`
  height: 100vh;
  overflow-y: auto;
  & :is(button, a) {
    &:is(:active, :focus, :focus-visible) {
      outline: 2px solid;
      outline-offset: -2px;
      border-radius: ${fromTheme('border_radius')};
    }
  }
` as typeof BaseList;
